module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('c-swipe', {
    directives: [{
      name: "square",
      rawName: "v-square"
    }],
    attrs: {
      "images": _vm.banners,
      "auto": 0
    }
  }), _vm._v(" "), _c('c-panel-container', [_c('c-panel', {
    attrs: {
      "title": _vm.goodsInfo.title,
      "desc": _vm.goodsInfo.desc
    }
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency0")(_vm.goodsInfo.price)))])])], 1), _vm._v(" "), _c('c-tab', {
    attrs: {
      "tabItems": _vm.tabItems
    },
    on: {
      "itemClick": _vm.tabTtemClickHandler
    }
  }), _vm._v(" "), (_vm.currentTab == _vm.tabItems[0].tabName) ? [_c('c-images', {
    attrs: {
      "imgItems": _vm.goodsDetailImgs
    }
  })] : _vm._e(), _vm._v(" "), (_vm.currentTab == _vm.tabItems[1].tabName) ? [_c('div', {
    staticClass: "goods-text-info",
    domProps: {
      "innerHTML": _vm._s(_vm.goodsDetailText)
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('c-footer', [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.buy($event)
      }
    }
  }, [_c('div', [_vm._v("立即购买")])])], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "view-fixed",
      rawName: "v-view-fixed"
    }],
    staticClass: "weui-mask",
    class: [_vm.buying ? 'mask-show' : 'mask-hide', _vm.maskRealHide ? 'mask-real-hide' : ''],
    on: {
      "click": _vm.closeMask
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    class: [_vm.buying ? 'weui-actionsheet_toggle' : '']
  }, [_c('div', {
    staticClass: "choose-count"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('c-counter', {
    attrs: {
      "minValue": 1
    },
    model: {
      value: (_vm.selectCount),
      callback: function($$v) {
        _vm.selectCount = $$v
      },
      expression: "selectCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("总价")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("currency0")(_vm.selectCount * _vm.goodsInfo.price)))])]), _vm._v(" "), _c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.orderConfirm($event)
      }
    }
  }, [_vm._v("提交")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f94befe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/details/hardware-market/index.vue
// module id = 1066
// module chunks = 2